module.exports = __webpack_public_path__ + "static/media/music.b7288e64.jpg";